export default __webpack_public_path__ + "static/media/AI & Intelligent Automation-thumbnail.9d311fa7.png";